function padLocationPart(value) {
  return String(value).padStart(2, "0");
}

export function formatLocation(location) {
  if (location.is_hardline) {
    return `H${padLocationPart(location.row_number)}-${padLocationPart(location.bay_number)}`;
  }
  return `${location.row_number} - ${location.bay_number}`;
}

export function formatLocationLong(location) {
  if (location.is_hardline) {
    return `Hardline ${formatLocation(location)}`;
  }
  return `Row ${location.row_number} - Bay ${location.bay_number}`;
}

export function groupLocationsByRow(locations) {
  return locations.reduce((groups, location) => {
    const row = location.row_number;
    if (!groups[row]) {
      groups[row] = [];
    }
    groups[row].push(location);
    return groups;
  }, {});
}
